import React from 'react';
import PropTypes from 'prop-types';
import {Button} from "semantic-ui-react";
import {connect} from 'react-redux';
import {pickOriginalAction} from "./actions";
import ResourceId from "utils/ResourceId";

const mapDispatchToProps = (dispatch, ownerProps) => ({
    uploadOriginal: () => dispatch(pickOriginalAction(ownerProps.uploadForResource)),
});

const UploadImageButtonWithText = (props) => (
    <Button onClick={props.uploadOriginal}>Upload</Button>
);

const UploadImageButton = connect(null, mapDispatchToProps)(UploadImageButtonWithText);

UploadImageButton.propTypes = {
    uploadForResource: PropTypes.instanceOf(ResourceId)
};

export default UploadImageButton;



// WEBPACK FOOTER //
// ./public/pages/Images/UploadImageButton.jsx